"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateOfferSchema = exports.getOffersSchemaForProduct = exports.getOffersSchemaForProductList = void 0;
const price_formatter_1 = require("../utils/price-formatter");
const schema_utils_1 = require("../utils/schema-utils");
const merchant_return_policy_schema_1 = require("./merchant-return-policy-schema");
const organization_schema_1 = require("./organization-schema");
const shipping_details_schema_1 = require("./shipping-details-schema");
const getOffersSchemaForProductList = (inStock = true, price) => {
    if (!price) {
        return undefined;
    }
    return {
        '@type': 'Offer',
        price: (0, price_formatter_1.formatItemSchemaPriceToString)(price),
        availability: (0, schema_utils_1.getAvailability)(inStock),
        priceCurrency: 'USD',
    };
};
exports.getOffersSchemaForProductList = getOffersSchemaForProductList;
const getOffersSchemaForProduct = (productDetails, pageCatalogEntryId, offerUrl) => {
    if (!productDetails)
        return undefined;
    const product = productDetails?.product;
    const items = product?.items;
    const isSingleItem = items?.length === 1;
    let lowPrice;
    let highPrice;
    let offerCount;
    const isParentProduct = pageCatalogEntryId === product?.entryID;
    if (!isSingleItem) {
        const itemsByAdvertisedPrice = items &&
            [...items]
                // filters out any out of stock items with advertised price equals null
                ?.filter((item) => item?.advertisedPrice !== null)
                .sort((a, b) => {
                // remove currency symbol
                const aPrice = (0, price_formatter_1.formatItemSchemaPriceToNumber)(a?.advertisedPrice);
                const bPrice = (0, price_formatter_1.formatItemSchemaPriceToNumber)(b?.advertisedPrice);
                // handle equality
                if (aPrice === bPrice) {
                    return 0;
                }
                // nulls sort after anything else
                else if (!aPrice) {
                    return 1;
                }
                else if (!bPrice) {
                    return -1;
                }
                // highest sorts first
                else {
                    return bPrice - aPrice;
                }
            });
        offerCount = items?.length;
        // Last item
        lowPrice = itemsByAdvertisedPrice?.slice(-1)[0]?.advertisedPrice;
        // First item
        highPrice = itemsByAdvertisedPrice && itemsByAdvertisedPrice[0]?.advertisedPrice;
    }
    const isFreeShipping = productDetails?.shippingMessage?.includes('FREE');
    const shouldSpecifiyDeliveryTime = productDetails?.shippingTimeframe?.includes('1-3');
    return isParentProduct && !isSingleItem
        ? generateAggregateOfferSchema(lowPrice || '0', highPrice || '0', offerCount?.toString(), offerUrl, product?.inStock)
        : (0, exports.generateOfferSchema)(product?.price || '0', offerUrl, product?.inStock, isFreeShipping, shouldSpecifiyDeliveryTime);
};
exports.getOffersSchemaForProduct = getOffersSchemaForProduct;
const generateAggregateOfferSchema = (lowPrice, highPrice, offerCount, offerUrl, inStock = true) => {
    return {
        itemCondition: 'https://schema.org/NewCondition',
        lowPrice: (0, price_formatter_1.formatItemSchemaPriceToString)(lowPrice),
        highPrice: (0, price_formatter_1.formatItemSchemaPriceToString)(highPrice),
        offerCount: offerCount,
        priceCurrency: 'USD',
        seller: (0, organization_schema_1.getOrganizationSchema)(),
        url: offerUrl,
        availability: (0, schema_utils_1.getAvailability)(inStock),
        '@type': 'AggregateOffer',
    };
};
const generateOfferSchema = (price, offerUrl, inStock = true, ifFreeshipping = true, shouldSpecifiyDeliveryTime = true) => {
    return {
        itemCondition: 'https://schema.org/NewCondition',
        priceCurrency: 'USD',
        seller: (0, organization_schema_1.getOrganizationSchema)(),
        ...(offerUrl && { url: offerUrl }),
        ...(0, merchant_return_policy_schema_1.getMerchantReturnPolicySchema)(),
        ...(0, shipping_details_schema_1.getShippingDetailsSchema)(ifFreeshipping, shouldSpecifiyDeliveryTime),
        availability: (0, schema_utils_1.getAvailability)(inStock),
        price: (0, price_formatter_1.formatItemSchemaPriceToString)(price),
        '@type': 'Offer',
    };
};
exports.generateOfferSchema = generateOfferSchema;
//# sourceMappingURL=offer-schema.js.map